import {
  VuexModule,
  Module,
  getModule,
  MutationAction,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";
import { Questionnaire, SendAnswersDTO } from "~/dal/questionare";
import { QuestionareService } from "@/services/api/questionare.service";

@Module({
  dynamic: true,
  store,
  name: "questionareModule",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class QuestionareVuexModule extends VuexModule {
  questionsList: Questionnaire[] = [];
  needCheckQuestionnaire: boolean = true;
  showQuestionnaire: boolean = false;

  @Mutation setneedCheckQuestionnaire(val: boolean) {
    this.needCheckQuestionnaire = val;
  }

  @Mutation setshowQuestionnaire(val: boolean) {
    this.showQuestionnaire = val;
  }

  @Action
  public async sendAnswers(req: SendAnswersDTO) {
    await QuestionareService.sendAnswers(req);
  }

  @MutationAction
  public async getQuestionnaire() {
    const questionsList = await QuestionareService.getQuestionnaire();
    return { questionsList };
  }
}

export const QuestionareModule = getModule(QuestionareVuexModule);
